import { LanguageContext } from 'providers/LanguageProvider';
import { useContext } from 'react';

// Custom hook that shorthands the LanguageContext.
const useAppLanguage = () => useContext(LanguageContext);

export default useAppLanguage;
